/**
 * Return continer props nescesary for tracking
 */
export default (container) => {
  const props = {
    fareItemInteractionType: container.fareItemInteractionType,
  };
  // Tracking props
  props.eventType = (container && container.tracking && container.tracking.eventType) || null;
  props.eventCategory =
    (container && container.tracking && container.tracking.eventCategory) || null;
  props.flexibleDates = container.tracking && !!container.tracking.flexibleDates;
  props.passengerCount = (container.tracking && container.tracking.passengerCount) || null;
  props.promoCode = (container.tracking && container.tracking.promoCode) || null;

  // Prepopulation props
  props.airlineIataCode =
    (container && container.prePopulation && container.prePopulation.airlineIataCode) || null;
  props.flightType =
    (container && container.prePopulation && container.prePopulation.flightType) || null;
  props.departureDateStart =
    (container &&
      container.prePopulation &&
      container.prePopulation.departure &&
      container.prePopulation.departure.start) ||
    null;
  props.returnDateEnd =
    (container &&
      container.prePopulation &&
      container.prePopulation.return &&
      container.prePopulation.return.end) ||
    null;

  // Page context
  props.siteEdition = (container.pageContext && container.pageContext.siteEdition) || null;

  // Integration settings
  props.v2DeepLinkApiSettings =
    container.integrationSettings && container.integrationSettings.v2DeepLinkApiSettings
      ? container.integrationSettings.v2DeepLinkApiSettings
      : null;

  // Component metadata
  props.tagName = (container.meta && container.meta.tag) || null;

  return props;
};
